export default {
  setMotivatorsListState(state, data) {
    state.motivatorsList = data;
  },
  addMotivatorItemState(state, data) {
    state.motivatorsList.push(data.slug);
  },
  removeMotivatorItemState(state, data) {
    let list = state.motivatorsList;
    list.splice(list.indexOf(data.slug), 1);
  }
};
